import MarkdownParserBuilder from './MarkdownParserBuilder';
import MarkdownSerializerBuilder from './MarkdownSerializerBuilder';
import SchemaBuilder from './SchemaBuilder';
export const markdown = {
  MarkdownParserBuilder: MarkdownParserBuilder,
  MarkdownSerializerBuilder: MarkdownSerializerBuilder,
  SchemaBuilder: SchemaBuilder
};
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/proseMirror/markdown', null);